var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "px-4 title primary--text"
  }, [_vm._v(_vm._s(_vm.name))]), _c('Scroller', {
    attrs: {
      "icon": _vm.$size(64)
    }
  }, [_vm._l(_vm.items, function (item) {
    return _c('div', {
      key: "items-item-".concat(item.m_ID),
      staticClass: "ml-4",
      style: {
        width: _vm.$size(64) + 'px'
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/item/".concat(item.m_ID)
      }
    }, [_c('v-avatar', {
      attrs: {
        "size": _vm.$size(64)
      }
    }, [_c('v-img', {
      attrs: {
        "src": _vm.$asset.itemicon.format(item.m_ID) + '.jpg'
      }
    })], 1), _c('div', {
      staticClass: "caption text-center two-lines"
    }, [_vm._v(_vm._s(_vm.$name(item.m_Name)))])], 1)], 1);
  }), _c('div', {
    staticClass: "pl-4"
  })], 2), !_vm.items.length ? _c('KeyValue', {
    staticClass: "px-4",
    attrs: {
      "k": _vm.$t('No Item')
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }